export default __webpack_public_path__ + "static/pragicts-cloudops-security-27f02d2dcbff6c32f3dbafccbd4c54b6.jpeg";